import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { store } from '../app/store';
import { postAPI, postAPIForm, getURL } from '../app/api';
import GlobalSearch from './GlobalSearch';
import GlobalMenu from './GlobalMenu';
import CustomImage from '../UIComponents/CustomImage';
import profile from "../assets/img/face24.jpg"
const { REACT_APP_BRANDURL } = process.env;

export default function GlobalHeader({ toggleSidebar }) {
  const navigate = useNavigate();
  const store_data = JSON.parse(store());
  // console.log('Store Data in Header:', localStorage.getItem('full_name'));
  const { org_id, name, role, class_id, id } = JSON.parse(store()) || {};

  const [API_URL, setAPIURL] = useState("");

  const fetchURL = async () => {
    const URL = await getURL();
    setAPIURL(URL);
  };

  useEffect(() => {
    fetchURL();
  }, [])
  // Logout handler
  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.clear();
    sessionStorage.clear();
    navigate('/login');
  };
  return (
    <header className='header header-sticky p-0 mb-0'>
      <nav class="navbar default-layout-navbar w-100 p-0 d-flex flex-row">
        <div class="navbar-menu-wrapper d-flex align-items-center">
          <button class="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize" onClick={toggleSidebar}>
            <span class="mdi mdi-menu"></span>
          </button>
          <div class="heading d-none d-md-block">
            <h2 class="title">Welcome Back, {localStorage.getItem('full_name') || 'ADMIN'}!</h2>
            {/* <p class="sub-title">It is the best time to manage your dashboard</p> */}
          </div>
          <ul class="navbar-nav navbar-nav-right">
            {/* <li class="nav-item dropdown">
                  <a class="nav-link count-indicator dropdown-toggle" id="notificationDropdown" href="#" data-bs-toggle="dropdown">
                    <i class="mdi mdi-bell-outline"></i>
                    <span class="count-symbol bg-danger"></span>
                  </a>
                  <div class="dropdown-menu dropdown-menu-end navbar-dropdown preview-list" aria-labelledby="notificationDropdown">
                    <h6 class="p-3 mb-0">Notifications</h6>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item preview-item">
                      <div class="preview-thumbnail">
                        <div class="preview-icon bg-success">
                          <i class="mdi mdi-calendar"></i>
                        </div>
                      </div>
                      <div class="preview-item-content d-flex align-items-start flex-column justify-content-center">
                        <h6 class="preview-subject font-weight-normal mb-1">Event today</h6>
                        <p class="text-gray ellipsis mb-0"> Just a reminder that you have an event today </p>
                      </div>
                    </a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item preview-item">
                      <div class="preview-thumbnail">
                        <div class="preview-icon bg-warning">
                          <i class="mdi mdi-cog"></i>
                        </div>
                      </div>
                      <div class="preview-item-content d-flex align-items-start flex-column justify-content-center">
                        <h6 class="preview-subject font-weight-normal mb-1">Settings</h6>
                        <p class="text-gray ellipsis mb-0"> Update dashboard </p>
                      </div>
                    </a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item preview-item">
                      <div class="preview-thumbnail">
                        <div class="preview-icon bg-info">
                          <i class="mdi mdi-link-variant"></i>
                        </div>
                      </div>
                      <div class="preview-item-content d-flex align-items-start flex-column justify-content-center">
                        <h6 class="preview-subject font-weight-normal mb-1">Launch Admin</h6>
                        <p class="text-gray ellipsis mb-0"> New admin wow! </p>
                      </div>
                    </a>
                    <div class="dropdown-divider"></div>
                    <h6 class="p-3 mb-0 text-center">See all notifications</h6>
                  </div>
                </li>
                <li class="nav-item d-none d-lg-block full-screen-link">
                  <a class="nav-link">
                    <i class="mdi mdi-fullscreen" id="fullscreen-button"></i>
                  </a>
                </li> */}
            <li class="nav-item nav-profile dropdown">
              <a class="nav-link dropdown-toggle" id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                <div class="nav-profile-img">
                  <img src={profile} alt="image" />
                  <span class="availability-status online"></span>
                </div>
                <div class="nav-profile-text">
                  <p class="mb-0">{localStorage.getItem('full_name') || 'ADMIN'}</p>
                </div>
              </a>
              <div class="dropdown-menu navbar-dropdown" aria-labelledby="profileDropdown">
                <a class="dropdown-item" href="#" onClick={handleLogout}>
                  <i class="mdi mdi-logout me-2 text-primary"></i> Signout </a>
              </div>
            </li>
          </ul>
          <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas">
            <span class="mdi mdi-menu"></span>
          </button>
        </div>
      </nav>
    </header>
  )
}
